import { Stack, Typography, Avatar, SxProps, Theme } from "@mui/material";

interface ChipLabelProps {
  name: string;
  count?: number;
  sx?: SxProps<Theme>;
}

export function ChipLabel({ name, count, sx }: ChipLabelProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 400,
        }}
      >
        {name}
      </Typography>
      {count && (
        <Avatar variant="circular" sx={{ height: 16, width: 16, fontSize: 12, ...sx }}>
          {count}
        </Avatar>
      )}
    </Stack>
  );
}
